(function() {
  function px(n) { return Math.round(n) + 'px'; }

  function measure() {
    const annSection = document.querySelector('.shopify-section-announcement-bar');
    const headerSection = document.querySelector('.shopify-section-header');
    let annH = 0;
    let headH = 0;

    if (annSection) annH = annSection.getBoundingClientRect().height || 0;
    if (headerSection) headH = headerSection.getBoundingClientRect().height || 0;

    document.documentElement.style.setProperty('--announcement-height', px(annH));
    document.documentElement.style.setProperty('--header-height', px(headH));
  }

  window.addEventListener('load', measure, { passive: true });
  window.addEventListener('resize', measure, { passive: true });
  document.addEventListener('shopify:section:load', measure);
  document.addEventListener('shopify:section:select', measure);
  document.addEventListener('shopify:section:deselect', measure);
  document.addEventListener('shopify:block:select', measure);
  document.addEventListener('shopify:block:deselect', measure);

  let scrollTimer = null;
  window.addEventListener('scroll', function() {
    if (scrollTimer) clearTimeout(scrollTimer);
    scrollTimer = setTimeout(measure, 120);
  }, { passive: true });

  try {
    const observer = new MutationObserver(measure);
    observer.observe(document.body || document.documentElement, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['style','class']
    });
  } catch(e) {}
})();
